import { createTheme } from '@mui/material/styles';
import { COLOR_GREEN, COLOR_GREEN_HOVER } from './styles/tokens';

const theme = createTheme({
	typography: {
		fontFamily: 'Dongle, sans-serif',
	},
	palette: {
		primary: {
			main: COLOR_GREEN,
			contrastText: '#ffffff',
		},
		success: {
			main: COLOR_GREEN,
			dark: COLOR_GREEN_HOVER,
			contrastText: '#ffffff',
		},
	},
	shape: {
		borderRadius: 8,
	},
});

export default theme;
